import { FC, useCallback } from "react";
import { Badge } from "@mui/material";
import { TCarrinhoAvulso, TCarrinhoItem } from "../types";
import { resolveUploadUrl } from "src/store/global.store";
import { LocalStorage } from "src/framework/commons";

interface IItemMini {
    item: TCarrinhoItem | TCarrinhoAvulso;
    index: number
}

const ItemMini: FC<IItemMini> = ({ item }) => {
    const uploadUrl = resolveUploadUrl(LocalStorage.get("solar.uploads", true) || null) || "";

const imgUrl = useCallback(() => {
    if ('componente' in item) {
        return `//${uploadUrl}${item.componente?.imagem ?? ""}`;
    } else if ('produto' in item) {
        return `//${uploadUrl}${item.produto?.imagem ?? ""}`;
    }

    return "";
}, [item, uploadUrl]);
    
    return <div className="ItemMini" style={{ margin: "4px 2px"}} >
        <Badge
            
            badgeContent={item.quantidade || ""}
            color="primary"
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
        >
            <img className="imagem" src={imgUrl()} alt="" />
            {/* <Avatar src={imgUrl()} style={{ boxShadow: theme.shadows[1] }} /> */}
        </Badge>
    </div>
}

export { ItemMini }